import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { format, subDays } from "date-fns";
import { useLearner } from "../../contexts/LearnerContext";
import { Card } from "../ui/Card";
import { courseTitle } from "../../utils/language";
import { spring } from "../../utils/motion";
const segmentColors = ["bg-brand/70", "bg-accent", "bg-good/60"];
export function WeeklyActivity() {
  const {
    courses
  } = useLearner();
  const reduce = useReducedMotion() ?? false;
  const today = new Date();
  const days = Array.from({
    length: 7
  }, (_, i) => ({
    label: format(subDays(today, 6 - i), "EEE"),
    parts: courses.map(c => c.weekXp[i] ?? 0)
  }));
  const totals = days.map(d => d.parts.reduce((a, b) => a + b, 0));
  const max = Math.max(60, ...totals);
  const weekTotal = totals.reduce((a, b) => a + b, 0);
  return <Card as="section" labelledBy="weekly-title" className="p-5" data-id="element-260" data-mp="wrm3cqfqohwo">
      <div className="flex items-baseline justify-between" data-id="element-261" data-mp="11knmjamzb3m2">
        <h2 id="weekly-title" className="text-sm font-bold text-ink-2" data-id="element-262" data-mp="2y8cilp9d3yae">
          This week
        </h2>
        <span className="text-sm text-ink-2" data-id="element-263" data-mp="2t99lcqzmiwcz">
          <span className="text-lg font-bold text-ink" data-id="element-264" data-mp="2takoqpp5q23k">{weekTotal}</span> XP
        </span>
      </div>
      <div className="mt-4 flex h-32 items-end gap-2" role="img" aria-label={`Weekly XP: ${totals.join(", ")}`} data-id="element-265" data-mp="37yxnfufmpz1r">
        {days.map((d, i) => <div key={i} className="flex h-full flex-1 flex-col items-center justify-end gap-1.5" data-id="element-266" data-mp="3gyu7fir2q9qh" data-mpi={i}>
            <motion.div initial={reduce ? false : {
          scaleY: 0
        }} animate={{
          scaleY: 1
        }} transition={{
          ...spring.smooth,
          delay: reduce ? 0 : 0.05 * i
        }} className="flex w-full origin-bottom flex-col-reverse overflow-hidden rounded-lg bg-sunken" style={{
          height: `${Math.max(8, totals[i] / max * 100)}%`
        }} data-id="element-267" data-mp="3cx8yu9lkohm3">
              {d.parts.map((xp, j) => xp > 0 ? <span key={j} className={`block w-full ${segmentColors[j % segmentColors.length]}`} style={{
            height: `${xp / Math.max(totals[i], 1) * 100}%`
          }} data-id="element-268" data-mp="1rlh2psf1ujou" /> : null)}
            </motion.div>
            <span className={`text-[11px] font-semibold ${i === 6 ? "text-ink" : "text-ink-2"}`} data-id="element-269" data-mp="4g4qzi1kpd2q">{d.label}</span>
          </div>)}
      </div>
      <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-ink-2" data-id="element-270" data-mp="eg5ezhae0hd9">
        {courses.map((c, j) => <li key={c.id} className="flex items-center gap-1.5" data-id="element-271" data-mp="jdoqwajm4i21" data-mpi={j}>
            <span className={`h-2.5 w-2.5 rounded-sm border border-line ${segmentColors[j % segmentColors.length]}`} aria-hidden="true" data-id="element-272" data-mp="o5f890gyw62y" />
            {courseTitle(c)}
          </li>)}
      </ul>
    </Card>;
}